import React from "react";
import { classNames } from "../../common/util/util-helpers";
import Tippy from "@tippyjs/react";

export default function Buttons({buttons = []}) {
    return (
        <React.Fragment>
            {buttons.filter(it => !it.isHidden).map((button, i) => (
                <Tippy
                    content={
                        <span>{button.title}</span>
                    }
                    disabled={!button.title}
                >
                <button
                    key={i}
                    onClick={button.onClick}
                    className={button.className ?? getType(button.type)}
                    disabled={button.disabled}
                >
                    {!!button.iconLeading && (
                        <button.iconLeading
                            className={
                                classNames(
                                    "w-5 h-5",
                                    !!button.label ? "mr-2" : undefined
                                )
                            }
                        />
                    )}

                    {button.label}

                    {!!button.iconTrailing && (
                        <button.iconTrailing className="w-5 h-5 ml-auto"/>
                    )}
                </button>
                </Tippy>

            ))}
        </React.Fragment>
    )
}

function getType(type) {
    switch (type) {
        case "primary":
            return "btn btn-primary";
        default:
            return "btn btn-outline";
    }
}
